const About = () => (
    <>
        <p style={{ fontStyle: 'italic' }}>.NET and Full Stack Web Developer</p>
        <p>
            Driven software developer with an agile mindset. <br />
            Skilled in software development, with a keen interest in software engineering and design.
        </p>
    </>
);

export default About;